import React,{useEffect, useState, useRef} from 'react';
import './credits.css';
import { playMusic, pauseMusic, setVolume, transitionVolume, stopMusic, isPlaying, playEffects, setVolumeEffects } from '../musicEngine/musicEngine';
import whoosh from'../../m/whoosh.js'
import click from'../../m/click.js'
import menu from'../../m/menu.js'

function Credits({goMenu, language, hzAdjuster}) {
    const wrap = useRef(null);

    let textTranslation = {
      en:{
        credits:"Credits",
        story:"Story, art, animations, code and design by",
        translation:"Translation and editing by",
        thanks:"Great thanks to my supporters:",
        music:"Music:",
        sfx:"Sound effects:",
        fonts:"Fonts:",
      },
      ru:{
        credits:"Титры",
        story:"Сюжет, рисунки, анимация, код и дизайн -",
        translation:"Перевод и редактирование -",
        thanks:"Отдельное спасибо за помощь:",
        music:"Музыка:",
        sfx:"Звуковые эффекты:",
        fonts:"Шрифты:",
      }
    }


    useEffect(() => {
      document.addEventListener('deviceready', deviceReadyFunc, false);
      function deviceReadyFunc() {
        document.addEventListener('backbutton', onBackButton, false);
      }
      function onBackButton(e) {
        e.preventDefault();
        goToMenu();
      }
      return () => {
        document.removeEventListener('deviceready', deviceReadyFunc, false);
        document.removeEventListener('backbutton', onBackButton, false);
      }
    },[]);

  useEffect(() => {
    async function start(){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    await changeSetting(wrap,"current.style.zIndex", 0, "", 10);
    if(!isPlaying){
      setVolume(0);
      playMusic(menu, 2000);
    }
    setTimeout(async () => {
    await transitionVolume(0.8,1200);
  }, 100);
  }
  start();
},[]);

  async function goToMenu(){
    await changeSetting(wrap,"current.style.zIndex", 10, "", 10);
    await transitionVolume(0,300);
    setVolumeEffects(0.5);
    playEffects(whoosh, false);
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
    goMenu();
  }

  function changeSetting(obj, setting, changeTo, um, speed, char){
    speed = speed*2*hzAdjuster;
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
    //  if(char){//delete
    //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
    //}
    //  let slowDownCounter=0;
      let slower = 8;
      change();
    function change(){
      //slowDownCounter++;
    //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
    //    slower+=3; //slower of char
    //  }
    //  console.log(slower);
      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  requestAnimationFrame(change);
  return;
  }
  });
  }

return(
<div className='menu'>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:1,zIndex:10}}></div>
<div className="blurtop"></div>
<div className="creditTop">
<div className="arrowBack2" onClick={goToMenu}>
    <div></div>
</div>
<h2>{textTranslation[language]["credits"]}</h2>
</div>
<div className="credits">
<h3>{textTranslation[language]["story"]} <a href="https://almondraf1.itch.io/" target="_blank"><span>AlmondRaf</span></a></h3>
<h3>{textTranslation[language]["translation"]} <a href="https://giantapple.newgrounds.com/" target="_blank"><span>GiantApple</span></a></h3>
<h3>{textTranslation[language]["thanks"]}</h3>
<ul>
  <li>CuteKitten16</li>
  <li>No State</li>
  <li>Biglo</li>
  <li>Mald</li>
  <li>Chingiz</li>
</ul>
<h3>{textTranslation[language]["music"]}</h3>
<ul className="ulCredits">
  <li>Junior Prankster Alt - Light Mid-Tempo Dramedy Bed; Marimba, Percussion by Groove_Committee, licensed via Pond5</li>
  <li>Seductive Erotic Sexy Slow R&B (60-Secs Version) by VibesbySquad, licensed via Pond5</li>
  <li>Quirky Clumsy Documentary Orchestral by MylesMusic, licensed via Pond5</li>
  <li>Quirky Funny Awkward Clumsy Background Music Loop 2 by MylesMusic, licensed via Pond5</li>
  <li>J050 - Inspirational Jazz Sexy Mood (Advertising, Background, Cue , Youtube) by PandemicFreeSound, licensed via Pond5</li>
  <li>Sunrise In The Fairytale Forest - Loop 1 by NobouMusic, licensed via Pond5</li>
  <li>Dark Playful Cinematic Dreamy Piano Ambient by futurebeats, licensed via Pond5</li>
  <li>Playful Dreamy Bright Background Piano Cinematic by futurebeats, licensed via Pond5</li>
  <li>Relaxing Inspiring Dreamy Bright Background Percussion Corporate by futurebeats, licensed via Pond5</li>
  <li>Playful Background Positive Inspirational Percussion Corporate by futurebeats, licensed via Pond5</li>
  <li>The Mouse Burglar Dramedy Cartoon Fun Suspense 35 Second by rbaudio, licensed via Pond5</li>
  <li>Unquiet Mood by FS_Production, licensed via Pond5</li>
  <li>Sad Story by RomanSound, licensed via Pond5</li>
  <li>Mockery Long - Mischief/Playful Cinematic Track (Video Game Music - Rpg - Loop) by AndrosProducer, licensed via Pond5</li>
  <li>Slow Sax Blues With Jazz And A Sensual - Seductive Sax Solo by lammont69893, licensed via Pond5</li>
  <li>Funk Play by AFKARE, licensed via Pond5</li>
</ul>
<h3>{textTranslation[language]["sfx"]}</h3>
<ul className="ulCredits">
  <li>Activity,Class,Listening To Teacher by bigroomsound, licensed via Pond5</li>
  <li>Human, Whistle by SoundIdeasCom, licensed via Pond5</li>
  <li>Massager, Vibrator by SoundIdeasCom, licensed via Pond5</li>
  <li>Poof, Cartoon by SoundIdeasCom, licensed via Pond5</li>
  <li>Reaction, Crowd by SoundIdeasCom, licensed via Pond5</li>
  <li>Creative Originality Wobble Whoosh Transition 79 by JGaudio, licensed via Pond5</li>
  <li>Sound - Fast Subtle Waiting by agcnf_media, licensed via Pond5</li>
  <li>Instant Message Bubble Pop by Ghetty, licensed via Pond5</li>
  <li>Sweet Complete Button by TPF, licensed via Pond5</li>
  <li>Fail3 by AppSound, licensed via Pond5</li>
  <li>Small Clock Ticking Short by SoundJay, licensed via Pond5</li>
  <li>Ta Da Sound by orangefreesounds, licensed via Pond5</li>
  <li>Click Button by StefanoCremona, licensed via Pond5</li>
  <li>Casual Game Award Sound Achievements Or Button Click 43 by Crebbs, licensed via Pond5</li>
  <li>Crowd Yay 02 by lynnepublishing, licensed via Pond5</li>
  <li>Fart 01 by jabameister, licensed via Pond5</li>
  <li>Loud Kiss by FxProSound, licensed via Pond5</li>
  <li>Door Handle Opening by FxProSound, licensed via Pond5</li>
  <li>Humans Eat Drink Mouth Smack Lick Tongue Fast by Soundideas1, licensed via Pond5</li>
  <li>Cartoon Fist-Fight, Several Fast Punches And Swooshes, Brawl by filmsound, licensed via Pond5</li>
  <li>Large Campus Cafeteria by jdgehlert, licensed via Pond5</li>
  <li>Trumpet Fail Sound Effect by orangefreesounds, licensed via Pond5</li>
  <li>Indoor Crowd Chatter by applehillstudios, licensed via Pond5</li>
  <li>Jump Scare Horror by orangefreesounds, licensed via Pond5</li>
  <li>Water Bottle Spill 1 by StormwaveAudio, licensed via Pond5</li>
  <li>Vinyl Scratch 5 by StockXL, licensed via Pond5</li>
  <li>Comedy Drums by zdravinjo, licensed via Pond5</li>
  <li>Infographic Pop 03 by SplashStudio, licensed via Pond5</li>
  <li>Cartoon Wah Wah Trumpet by TRUMPET_GOD, licensed via Pond5</li>
  <li>Idea 09 (Ding, Ring, Bell, Game) by garnavutka787, licensed via Pond5</li>
  <li>Barefoot On Grass 8547 by royaltysample, licensed via Pond5</li>
  <li>Relaxing Nature Sounds Birds Singing In The Morning Forest by mazfox, licensed via Pond5</li>
  <li>Cartoon Pops 07 (Pop, Bubble, Plop, Interface, Menu) by garnavutka787, licensed via Pond5</li>
  <li>Quiz Time Out by Tomasz_Redman, licensed via Pond5</li>
  <li>Bee Flying And Buzzing 5 by baydock549, licensed via Pond5</li>
  <li>Man Male Pain Groan Hurt Scream 4 by IktaSFX, licensed via Pond5</li>
  <li>Crying Woman Human Vocalization 10 by hcdaudio, licensed via Pond5</li>
  <li>Clicky Typing 1 by roguewavessoundeffects, licensed via Pond5</li>
  <li>Female Sensual Moaning by Soundwell, licensed via Pond5</li>
  <li>Shiny Upbeat Transition Chimes by orangefreesounds, licensed via Pond5</li>
  <li>School Bell Chime by orangefreesounds, licensed via Pond5</li>
  <li>Crying Woman Vocalization Sound 28 by hcdaudio, licensed via Pond5</li>
  <li>Wood, Handle, Thin Wooden Stick, Dropping On Wooden Floor, Single 01, Vadi by vadisound, licensed via Pond5</li>
  <li>Message Sent 03 (Smartphone, Notification, Chat) by garnavutka787, licensed via Pond5</li>
  <li>Pencil Check Mark by quietsubfx516, licensed via Pond5</li>
  <li>Closing Wooden Door. by stocksnapper, licensed via Pond5</li>
  <li>Melodic Silence (Ambient, 2 Sec Stinger) by TeraMangalaMeditationMusic, licensed via Pond5</li>
  <li>Menu Slide, Page Turn, Paper Swoosh, Ui Transition, Slide In by crunchpixstudio116, licensed via Pond5</li>
  <li>Notification Ding, Simple Alert, Ui Chime, Positive Alert, Message Sound by crunchpixstudio116, licensed via Pond5</li>
  <li>Silly Trumpet Fail Sound Effect by orangefreesounds, licensed via Pond5</li>
  <li>Uialert_Chapter Completed 03A_Sndbts_Sde-V5 by SoundBits, licensed via Pond5</li>
  <li>Fast Energetic Bamboo Stick Whoosh by Tropicalski, licensed via Pond5</li>
  <li>phoebeMessage by AlmondRaf</li>
  <li>phoebeMessage2 by AlmondRaf</li>
  <li>ahem by AlmondRaf</li>
  <li>tsk by AlmondRaf</li>
  <li>zipper by AlmondRaf</li>
  <li>snap by AlmondRaf</li>
  <li>spank by AlmondRaf</li>
  <li>shirtOff by AlmondRaf</li>
  <li>skirtOff by AlmondRaf</li>
  <li>muhehe by AlmondRaf</li>
  <li>duh by AlmondRaf</li>
  <li>cum0 by AlmondRaf</li>
  <li>cum1 by AlmondRaf</li>
  <li>cum2 by AlmondRaf</li>
  <li>mmm_shy by AlmondRaf</li>
  <li>mmm_question by AlmondRaf</li>
  <li>mmm_nice by AlmondRaf</li>
  <li>moan0 by AlmondRaf</li>
  <li>moan1 by AlmondRaf</li>
  <li>moan2 by AlmondRaf</li>
  <li>moan3 by AlmondRaf</li>
  <li>moan4 by AlmondRaf</li>
  <li>moan5 by AlmondRaf</li>
  <li>moan6 by AlmondRaf</li>
  <li>moan7 by AlmondRaf</li>
  <li>moan8 by AlmondRaf</li>
  <li>moan9 by AlmondRaf</li>
  <li>moan10 by AlmondRaf</li>
  <li>moan11 by AlmondRaf</li>
  <li>moan12 by AlmondRaf</li>
  <li>moan13 by AlmondRaf</li>
  <li>moan14 by AlmondRaf</li>
  <li>moan15 by AlmondRaf</li>
  <li>hollow by AlmondRaf</li>
  <li>hollow1 by AlmondRaf</li>
  <li>hollow2 by AlmondRaf</li>
  <li>hollow3 by AlmondRaf</li>
  <li>hmm by AlmondRaf</li>
  <li>gig2 by AlmondRaf</li>
  <li>hemhem by AlmondRaf</li>
  <li>breathing by AlmondRaf</li>
  <li>gig by AlmondRaf</li>
  <li>duh by AlmondRaf</li>
  <li>femaleArousal9 by AlmondRaf</li>
  <li>femaleArousal10 by AlmondRaf</li>
  <li>femaleArousal14 by AlmondRaf</li>
  <li>femaleArousal21 by AlmondRaf</li>
  <li>femaleMoaning by AlmondRaf</li>
  <li>femaleMoaning2 by AlmondRaf</li>
  <li>femaleMoaning3 by AlmondRaf</li>
  <li>femaleMoaning4 by AlmondRaf</li>
  <li>femaleMoaning5 by AlmondRaf</li>
  <li>femaleMoaning7 by AlmondRaf</li>
  <li>femaleMoaning10 by AlmondRaf</li>
  <li>femaleMoaning11 by AlmondRaf</li>
  <li>femaleMoaning12 by AlmondRaf</li>
  <li>femaleMoaning13 by AlmondRaf</li>
  <li>femaleMoaning14 by AlmondRaf</li>
  <li>femaleMoaning15 by AlmondRaf</li>
  <li>femaleMoaning16 by AlmondRaf</li>
  <li>orgasm7 by AlmondRaf</li>
  <li>wetPussy by AlmondRaf</li>
</ul>
<h3>{textTranslation[language]["fonts"]}</h3>
<ul className="ulCredits">

  <li>Font: "Caveat"
  <br/>© 2014 The Caveat Project Authors
  <br/>Designed by Pablo Impallari
  <br/><a href="https://openfontlicense.org/open-font-license-official-text/" target="_blank">SIL OPEN FONT LICENSE Version 1.1</a> - 26 February 2007</li>

  <li>Font: "IBM Plex Mono"
  <br/>© 2017 IBM Corp.
  <br/>Designed by Mike Abbink, Bold Monday
  <br/><a href="https://openfontlicense.org/open-font-license-official-text/" target="_blank">SIL OPEN FONT LICENSE Version 1.1</a> - 26 February 2007</li>

  <li>Font: "Jost"
  <br/>© 2020 The Jost Project Authors
  <br/>Designed by Owen Earl
  <br/><a href="https://openfontlicense.org/open-font-license-official-text/" target="_blank">SIL OPEN FONT LICENSE Version 1.1</a> - 26 February 2007</li>

  <li>Font: "Playwrite FR Moderne"
  <br/>© 2023 The Playwrite Project Authors
  <br/>Designed by TypeTogether, Veronika Burian, José Scaglione
  <br/><a href="https://openfontlicense.org/open-font-license-official-text/" target="_blank">SIL OPEN FONT LICENSE Version 1.1</a> - 26 February 2007</li>

  </ul>
</div>
<div className="blurbottom"></div>
</div>
);

}

export default Credits;
